import React, { useState, useCallback, useRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Collapse from "react-bootstrap/Collapse";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import Button from "../Common/Button";
import "./Filters.scss";
import FiltersIcon from "../../constants/FiltersIcon";

const MultipleFilterDropdown = ({
  categories,
  options,
  applyFilters,
  dateJoined = false,
  hasRecordingCheck = false,
  resetFilters,
  selectedFilters = {},
  setSelectedFilters = () => {},
  isApplied = false,
  backgroundColor = "",
  marginRight = "16px",
  alignHeight = false,
  isValueToStoreId = () => false,
}) => {
  const [searchTerms, setSearchTerms] = useState({});
  const [openStatus, setOpenStatus] = useState({});
  const [openDate, setOpenDate] = useState(false);
  const [openRecording, setOpenRecording] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [isRecordingAttach, setIsRecordingAttach] = useState(false);
  const [endDate, setEndDate] = useState("");

  const hideRef = useRef(null);

  const handleCheckboxChange = useCallback(
    (category, id, label) => {
      // Check if the category is "classroom" to store the id instead of label
      const valueToStore =
        category === "classroom" ||
        category === "organisations" ||
        isValueToStoreId(category)
          ? id
          : label;

      setSelectedFilters((prevState) => ({
        ...prevState,
        [category]: prevState[category]?.includes(valueToStore)
          ? prevState[category].filter((item) => item !== valueToStore)
          : [...(prevState[category] || []), valueToStore],
      }));
    },
    [setSelectedFilters]
  );

  const handleSearchChange = (category, value) => {
    setSearchTerms((prevState) => ({
      ...prevState,
      [category]: value,
    }));
  };

  const handleAccordionToggle = (category) => {
    setOpenStatus((prevState) => ({
      ...prevState,
      [category]: !prevState[category],
    }));
  };

  const handleApply = () => {
    applyFilters(selectedFilters, startDate, endDate, isRecordingAttach); // Pass startDate and endDate here
    hideRef.current.click();
  };

  const handleReset = () => {
    setSelectedFilters({});
    setSearchTerms({});
    setStartDate("");
    setEndDate("");
    setIsRecordingAttach(false);
    resetFilters([]);
    hideRef.current.click();
  };

  const renderAccordions = () => {
    return categories.map((category) => (
      <div key={category}>
        <div
          aria-controls={`collapse-content-${category}`}
          aria-expanded={openStatus[category]}
          className="d-flex justify-content-between"
          onClick={() => handleAccordionToggle(category)}
          style={{
            padding: "12px 10px 12px 10px",
          }}
        >
          <div
            style={{
              fontFamily: "Plus Jakarta Sans",
              fontSize: "16px",
              fontWeight: 500,
              lineHeight: "19.36px",
              textAlign: "left",
              color: "#5A6A85",
              textTransform: "capitalize",
            }}
          >
            {category}
          </div>
          <img
            src={openStatus[category] ? "/ChevronUp.svg" : "/ChevronDown.svg"}
            alt="right-arrow"
          />
        </div>

        <Collapse in={openStatus[category]}>
          <div
            id={`collapse-content-${category}`}
            style={{
              padding: "10px 11px 10px 11px",
              backgroundColor: "#F1F3FA",
              // height: "300px",
              // overflow: "auto",
            }}
          >
            <InputGroup>
              <Form.Control
                aria-label={`Search ${category}`}
                aria-describedby="basic-addon1"
                placeholder={`Search ${category}`}
                value={searchTerms[category] || ""}
                onChange={(e) => handleSearchChange(category, e.target.value)}
                style={{
                  color: "#8B97A8",
                  background: "white",
                  borderRightColor: "white",
                }}
              />
              <InputGroup.Text
                id="basic-addon1"
                style={{
                  color: "#8B97A8",
                  background: "white",
                  borderLeftColor: "white",
                }}
              >
                <img src="/Union.svg" alt="search-icon" />
              </InputGroup.Text>
            </InputGroup>
            {(searchTerms[category]
              ? options[category]?.filter((option) =>
                  option?.label
                    ?.toLowerCase()
                    ?.includes(searchTerms[category]?.toLowerCase())
                )
              : options[category]
            )?.map((option) => (
              <div
                key={option.id || option.label} // Use option.id if available, fallback to option.label
                style={{
                  padding: "12px 10px 12px 10px",
                }}
              >
                <Form.Check
                  checked={selectedFilters[category]?.includes(
                    category === "classroom" ||
                      category === "organisations" ||
                      isValueToStoreId(category)
                      ? option.id
                      : option.label
                  )}
                  onChange={() =>
                    handleCheckboxChange(category, option.id, option.label)
                  }
                  type="checkbox"
                  id={`checkbox-${option.id || option.label}`} // Similarly, ensure the id is unique
                  label={option.label}
                />
              </div>
            ))}
          </div>
        </Collapse>
      </div>
    ));
  };

  return (
    <div className="filter-students">
      <button ref={hideRef} style={{ display: "none" }}>
        hidden button
      </button>
      <Dropdown flip={false}>
        <Dropdown.Toggle
          id="dropdown-basic"
          style={{
            color: "#8B97A8",
            background: backgroundColor ? backgroundColor : "white",
            borderColor: backgroundColor ? backgroundColor : "white",
            padding: "0px",
            margin: backgroundColor
              ? `0px ${marginRight} 0px 10px`
              : "0px 10px",
            height: backgroundColor || alignHeight ? "42px" : "",
          }}
        >
          <div
            className="filters-icon mx-"
            style={{
              backgroundColor: backgroundColor ? backgroundColor : "white",
              height: backgroundColor || alignHeight ? "42px" : "",
            }}
          >
            {isApplied ? (
              <FiltersIcon
                className={"mr-2"}
                style={{
                  cursor: "pointer",
                  backgroundColor: "transparent !important",
                  border: "none !important",
                  color: "blue",
                }}
                size={24}
              />
            ) : (
              <img
                style={{
                  cursor: "pointer",
                  backgroundColor: "transparent !important",
                  border: "none !important",
                }}
                src="/Filter.svg"
                alt="Filter"
                className="mr-2"
              />
            )}
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu
          style={{
            minHeight: "210px",
            width: "333px",
            padding: "10px",
            borderRadius: "5px",
            position: "absolute",
            left: "-100px !important",
          }}
        >
          <div style={{ maxHeight: "280px", overflowY: "auto" }}>
            {renderAccordions()}
            {dateJoined && (
              <>
                <div
                  aria-controls="collapse-content"
                  aria-expanded={openDate}
                  onClick={() => setOpenDate(!openDate)}
                  className="d-flex justify-content-between"
                  style={{
                    padding: "12px 10px 12px 10px",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Plus Jakarta Sans",
                      fontSize: "16px",
                      fontWeight: 500,
                      lineHeight: "19.36px",
                      textAlign: "left",
                      color: "#5A6A85",
                    }}
                  >
                    Date
                  </span>
                  <img
                    src={openDate ? "/ChevronUp.svg" : "/ChevronDown.svg"}
                    alt="right-arrow"
                  />
                </div>
                <Collapse in={openDate}>
                  <div
                    style={{
                      padding: "10px 11px 10px 11px",
                      backgroundColor: "#F1F3FA",
                    }}
                  >
                    <label htmlFor="date" className="col-form-label">
                      From start date
                    </label>
                    <input
                      type="date"
                      value={startDate}
                      className="form-control"
                      id="date"
                      style={{
                        background: "white",
                      }}
                      onChange={(e) => {
                        setStartDate(e.target.value);
                      }}
                    />
                    <label htmlFor="date" className="col-form-label">
                      To end date
                    </label>
                    <input
                      type="date"
                      value={endDate}
                      className="form-control"
                      id="date"
                      onChange={(e) => {
                        setEndDate(e.target.value);
                      }}
                      style={{
                        background: "white",
                      }}
                    />
                  </div>
                </Collapse>
              </>
            )}
            {hasRecordingCheck && (
              <>
                <div
                  aria-controls="collapse-content"
                  aria-expanded={openRecording}
                  onClick={() => setOpenRecording(!openRecording)}
                  className="d-flex justify-content-between"
                  style={{
                    padding: "12px 10px 12px 10px",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Plus Jakarta Sans",
                      fontSize: "16px",
                      fontWeight: 500,
                      lineHeight: "19.36px",
                      textAlign: "left",
                      color: "#5A6A85",
                    }}
                  >
                    Recording Availability
                  </span>
                  <img
                    src={openRecording ? "/ChevronUp.svg" : "/ChevronDown.svg"}
                    alt="right-arrow"
                  />
                </div>
                <Collapse in={openRecording}>
                  <div
                    style={{
                      padding: "12px 10px 12px 10px",
                    }}
                  >
                    <Form.Check
                      checked={isRecordingAttach}
                      onChange={() => setIsRecordingAttach(!isRecordingAttach)}
                      type="checkbox"
                      id={`checkbox-has-attach-recording`} // Similarly, ensure the id is unique
                      label={"Include attached recording"}
                    />
                  </div>
                </Collapse>
              </>
            )}
          </div>
          <br />
          <div className=" d-flex justify-content-between">
            <Button
              className="px-4"
              style={{
                width: "50%",
                height: "45px",
                borderRadius: "5px",
                backgroundColor: "white",
                border: "1px solid gray",
                color: "rgb(110, 116, 133)",
                fontFamily: "inherit",
                fontSize: "18px",
                cursor: "pointer",
              }}
              onClick={handleReset}
            >
              Reset
            </Button>
            <Button
              className="px-4 save-btn"
              style={{
                width: "50%",
                height: "45px",
                marginLeft: "20px",
                cursor: "pointer",
              }}
              onClick={handleApply}
            >
              Apply
            </Button>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default MultipleFilterDropdown;
